import type { Category, Product } from "./data";

export function getCategoryUrl(category: Category) {
    return "/c/" + category.id + (category.slug ? ("/" + category.slug) : "");
}

export function getProductUrl(product: Product) {
    return "/p/" + product.id + (product.slug ? ("/" + product.slug) : "");
}
